import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=9685334e&scoped=true"
import script from "./SendCode.vue?vue&type=script&lang=js"
export * from "./SendCode.vue?vue&type=script&lang=js"
import style0 from "./SendCode.vue?vue&type=style&index=0&id=9685334e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9685334e",
  null
  
)

export default component.exports